import type { FaireProductEntity } from "../../entity_types/product";

export const p_enhx2t322u: FaireProductEntity = {
  token: "p_enhx2t322u",
  type: "product",
  name: "Deep Sleep Blend Roll On |\u00a0Essential Oil Aromatherapy Roller",
  brandName: "Blue Sage",
  imageUrl:
    "https://cdn.faire.com/fastly/65d5bc8a60a55b58dccff52839774d1875b7a32699fbe114046490659bc64f39.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fb391ec597c8ff2ddbb7cc449bf1d42a7efefa259b0119a1172f75dfe8c44af2.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
